export class Secciones {
    constructor(
      public idSeccion: number,
      public titulo: string,
      public descripcion: string,
      public urlImagen: string,
      public usuAlta: number,
      public usuMod: number,
      public created_at: string,
      public updated_at: string
    ) {}
  }